var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { t } from "../../I18N";

import { loadMoreReferences } from "../../ConnectionsList/actions/actions";

export const LoadMoreRelationshipsButton = ({
  totalHubs,
  requestedHubs,
  action,
  loadMoreAmmount
}) => {
  if (requestedHubs < totalHubs) {
    const actionFunction = () => {
      action(requestedHubs + loadMoreAmmount);
    };

    let loadMoreAmmountDisplay = loadMoreAmmount;

    const hubsLeft = totalHubs - requestedHubs;
    if (hubsLeft < loadMoreAmmount) {
      loadMoreAmmountDisplay = hubsLeft;
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "text-center" }, void 0, /*#__PURE__*/
      _jsx("p", { className: "col-sm-12 text-center documents-counter" }, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, requestedHubs), " ", t('System', 'of'), " ", /*#__PURE__*/_jsx("b", {}, void 0, totalHubs), " ", t('System', 'hubs')
      ), /*#__PURE__*/
      _jsx("button", { onClick: actionFunction, className: "btn btn-default btn-load-more" }, void 0,
      `${loadMoreAmmountDisplay}`, " ", t('System', 'x more')
      )
      ));

  }

  return null;
};








export const mapStateToProps = ({ relationships }) => ({
  totalHubs: relationships.list.searchResults.get('totalHubs'),
  requestedHubs: relationships.list.searchResults.get('requestedHubs'),
  loadMoreAmmount: 10
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      action: loadMoreReferences
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadMoreRelationshipsButton);